import React, {Component} from 'react'
import '../styles/LandingPageEmployers.css'

import {
  Link,
} from 'react-router-dom'

import {
  Button,
  Card,
  Typography,
} from 'material-ui'

import ExpansionPanel, {
  ExpansionPanelDetails,
  ExpansionPanelSummary,
} from 'material-ui/ExpansionPanel';

import ExpandMoreIcon from 'material-ui-icons/ExpandMore';

import Fade from 'material-ui/transitions/Fade'

// import SubscriptionForm from './SubscriptionForm'
// import LandingPageInfoCard from './LandingPageInfoCard'

import {
  Accent,
  bgWhite,
  Primary,
  PurpleShadow,
  Title,
} from '../helper/consts'

const style = {
  ctaBtn:{
    marginRight: '21px',
    boxShadow: `0px 10px 50px -5px ${Accent}`,
    minWidth: '150px',
    minHeight: '50px',
    borderRadius: '50px',
    margin: '50px 0 100px 0',
  },
  infoSection:{
    maxWidth: '1180px',
    width: '100%',
    padding: '100px auto',
    height: 'min-content',
    backgroundColor:bgWhite,
    display: 'flex',
    // justify-content: space-around;
    // width: 100%;
    margin: '100px auto',
    // flex-wrap: wrap;
  },
  infoContainer:{
    display: 'flex',
    justifyContent: 'space-around',
    width: 'auto',
    margin: '50px 20px',
    flexDirection:'column',
    boxShadow: `0 25px 93px -10px ${PurpleShadow}, 0 -5px 33px -10px ${PurpleShadow}`,
    padding:'20px',
    borderRadius:'20px',
  },
  // infoColumn:{
  //   display: 'flex',
  //   flexDirection: 'column',
  //   maxWidth: '39%',
  //   width: '39%',
  //   minWidth: '310px',
  //   margin: '0 10px',
  // },
  infoTitle:{
    textAlign: 'right',
    margin: '10px 10px 20px',
    color: Accent,
    fontWeight:'800',
  },
  aboutTitle:{
    textAlign: 'center',
    margin: '10px 10px 20px',
    fontWeight:'400',
    color:Primary,
    fontSize:'1.3rem',
  },
  aboutText:{
    textAlign: 'center',
    margin: '10px 10px 20px',
    fontWeight:'400',
    color:Primary,
  },
  benefitTitle:{
    color:Primary,
    fontSize:'1.2rem',
  },
  benefitAbout:{
    lineHeight:'1.7rem',
    color:Primary,
  }
  // expansion:{
  //   boxShadow:'none',
  //   backgroundColor:'transparent',
  // }
}

const points = [
  {
    title:`Sign in to ${Title} – takes 1 min!`,
    message:`${Title} works with leading organiziations and employers to carefully distribute opportunities to excellent candidates. Gone are the days of spending hours tending to another online profile. We do the work of matching you to the perfect opportunity. Joining only takes 1 minute!`,
  },
  {
    title:`Review the career opportunity`,
    message:`When we have an opportunity for you, or someone in your network thinks you're just perfect for the opportunity, you'll get an invitation. Join today and let your network know how great you are.`,
  },
  {
    title:`Either Apply for or Share the career opportunity with your network`,
    message:`If you've received an job posting, it's because someone thinks either you would be perfect for it or that you might know someone who is. Send a special invitation today or put yourself forward for the opportunity!`,
  },
  {
    title:`Track your referral bonus potential within ${Title}.com`,
    message:`Partner organiziations offer incentive bonuses to reward everyone that had a hand in helping them find their perfect candidate. When you share a career opportunity, you can keep track of it and see any shared incentives if there's a successful candidate.`,
  },
  {
    title:`Receive an email once your referral is hired to receive your bonus!`,
    message:`If someone you've referred, or someone they've referred, is the successful candidate, then you'll be notified and you'll receive your share of the incentive reward given by the hiring company!`,
  },
]

export default class LandingPageNetworkers extends Component{
  constructor(){
    super();

    this.state = {
      expanded:false,
    }
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };


  render(){
    return (
      <section id="employers" style={style.infoSection} className="body">
        <Typography style={style.infoTitle} type={'display1'}>Networkers</Typography>
        <Typography className='cardWidth' style={style.aboutTitle} type={'subheading'}>Are you often asked by your employer, friends or recruitment professionals to tap into your network and refer top talent to fill vacancies?  If you’re someone with a robust, talented network that would like to be rewarded than <span id='titleBrandMark'>{Title}</span> is a network that you want to be invited to!</Typography>
        <Typography className='cardWidth' style={style.aboutTitle} type={'subheading'}>Once invited to <span id='titleBrandMark'>{Title}</span> here’s what you can expect:</Typography>
        <Card style={style.infoContainer} className="cardWidth">
          {points.map((point,i)=>{
            return(
              <Fade key={i} in={true}>
                <ExpansionPanel className='employerBenefit' expanded={this.state.expanded === `${i}`} onChange={this.handleChange(`${i}`)}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography style={style.benefitTitle}>{point.title}</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Typography style={style.benefitAbout}>
                      {point.message}
                    </Typography>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </Fade>
            )
          })}
        </Card>
        <Typography className='cardWidth' style={style.aboutText} type={'subheading'}>It’s that easy!</Typography>
        <Link
          to={{
            pathname: '/Join',
            state: { tab: 'signUp' }
          }}
        >
          <Button style={style.ctaBtn} raised color='accent'>Sign Up</Button>
        </Link>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LandingPageNetworkers.js